// services/pranayamma/deletePranayamma.js
import axiosInstance from '../axiosMiddleware';

export async function deletePranayamma({ pranayammaId }) {
  if (!pranayammaId) {
    throw new Error('Pranayama ID is required');
  }

  try {
    const response = await axiosInstance.delete(`/pranayamma/pranayamma/${pranayammaId}`);
    return response.data;
  } catch (error) {
    const msg = error?.response?.data?.message || error.message || 'Delete failed';
    console.error('Delete failed:', error);
    throw new Error(msg);
  }
}